export default __webpack_public_path__ + "static/media/familia-trend.bd3d7aff.svg";